import { useTranslation } from 'react-i18next';

import Spinner from 'components/Spinner/Spinner';

const LoadingView = () => {
  const { t } = useTranslation();

  return (
    <div className="h-full md:h-96 bg-white flex items-center justify-center gap-2">
      <span className="text-black">{t('loading')}</span>
      <Spinner variant="gray50" size="xs" />
    </div>
  );
};

export default LoadingView;
